export default __webpack_public_path__ + "static/media/search_momo.47499a98.jpg";